import { motion } from "framer-motion";
import { CircleUserRound } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const ROWS = [
    "Managing multiple daily medications",
    "People who sometimes forget doses",
    "Anyone wanting allergy & interaction awareness",
    "Caregivers helping loved ones",
];

export default function WhoItsFor() {
    return (
        <section className="px-6 py-14" data-testid="who-its-for-section">
            <motion.p
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, ease: EASE }}
                className="text-teal-dark font-bold text-[13px] tracking-[0.14em] uppercase"
            >
                Who it's for
            </motion.p>
            <motion.h2
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: 0.08 }}
                className="mt-3 font-extrabold tracking-tight leading-[1.08] text-4xl text-ink"
            >
                Who benefits most from Med Check Alarm?
            </motion.h2>
            <motion.p
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: 0.16 }}
                className="mt-4 text-black/55 text-[17px] leading-relaxed"
            >
                Whether you're managing multiple medications, caring for a loved one, or simply
                want better organisation — Med Check Alarm is designed for you.
            </motion.p>

            <div className="mt-9 space-y-3.5">
                {ROWS.map((row, i) => (
                    <motion.div
                        key={row}
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{ duration: 0.55, ease: EASE, delay: i * 0.07 }}
                        className="flex items-center gap-4 rounded-2xl border border-black/10 bg-cream px-5 py-4"
                        data-testid={`who-row-${i + 1}`}
                    >
                        <CircleUserRound size={30} className="text-teal shrink-0" strokeWidth={1.8} />
                        <span className="font-semibold text-[17px] leading-snug text-ink">{row}</span>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
